import React, { useState, useRef, useEffect } from "react";
import bgImage from "../assets/img/gratitude_card.jpg";
import HomeNav from "./Nav";

function Gratitude() {
  const canvasRef = useRef(null);
  const [receiver, setReceiver] = useState("");
  const [sender, setSender] = useState("");
  const [message, setMessage] = useState("");
  const [language, setLanguage] = useState("1");

  useEffect(() => {
    drawCanvas();
  }, [sender, receiver, message, language]);

  const handleReceiverChange = (event) => setReceiver(event.target.value);
  const handleSenderChange = (event) => setSender(event.target.value);
  const handleMessageChange = (event) => setMessage(event.target.value);

  const handleSelectLang = (e) => {
    setLanguage(e.target.value);
    setSender("");
    setReceiver("");
    setMessage("");
  }

  const drawCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    if (bgImage) {
      img.src = bgImage;
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        // Text styles
        ctx.fillStyle = "white";

        // Align & position
        if (language === "2") {
          ctx.textAlign = "right";  // Arabic → align right
        } else {
          ctx.textAlign = "left";  // English → align left
        }

        const startX = language === "2" ? canvas.width - 350 : canvas.width / 2 + 100;
        let y = canvas.height / 2 - 200;

        // Receiver line - BIG
        ctx.font = "bold 140px zainfontregular";
        if (receiver) {
          if (language === "2") {
            ctx.fillText(`شكرًا ${receiver}`, startX, y);
          } else {
            ctx.fillText(`Thank you ${receiver}`, startX, y);
          }
        }

        // Message - MEDIUM
        ctx.font = language === "1"?"100px zainfontregular": "80px zainfontregular";
        y += 130;
        wrapText(ctx, message, startX - (language === "2" ? 0 : 18), y, 1700, language ==="1" ? 85 : 75);

        // Sender - SMALLER
        ctx.font = "100px zainfontregular";
        if (sender) {
          y += 500; // move down
          if (language === "2") {
            ctx.fillText(`مع الامتنان، ${sender}`, startX, y);
          } else {
            ctx.fillText(`With gratitude, ${sender}`, startX, y);
          }
        }
      };
    }
  };

  // helper: wrap text into multiple lines
  const wrapText = (ctx, text, x, y, maxWidth, lineHeight) => {
    const words = text.split(" ");
    let line = "";
    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + " ";
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        ctx.fillText(line, x, y);
        line = words[n] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    ctx.fillText(line, x, y);
  };

  const handleDownload = () => {
    const canvas = canvasRef.current;
    const link = document.createElement("a");
    link.download = "zain-card.png";
    link.href = canvas.toDataURL();
    link.click();
  };

  return (
    <div dir="rtl" style={{ fontFamily: "zainfontregular" }}>
      <HomeNav />
      <div className="container page-up ">
        <div className="row">
          <div className="col-md col-lg mb-4">
            <div className="text-center container align-items-center justify-content-center ">
              <canvas
                style={{ borderRadius: "15px", width: "100%", height: "auto" }}
                className="card-img-top "
                ref={canvasRef}
              />
            </div>
          </div>
          <div className="col-md col-lg mb-4">
            <div className="row">
              <div className="col-md col-lg mx-auto">
                <div className="card-body">
                  <label htmlFor="size" className="form-label">
                    اختر لغة البطاقة Choose card language
                  </label>
                  <div className="mb-3 mt-3 ">
                    <div onChange={handleSelectLang} className="d-flex row bg-white border rounded p-3">
                      <div className="d-flex col">
                          <label style={{ marginLeft: "10px", cursor: "pointer"}} htmlFor="langAr" >عربي </label>
                        <input type="radio" value="2" name="lang" className="radio" id="langAr"/>
                      </div>
                      <div className="d-flex col">
                        <label style={{ marginLeft: "10px", cursor: "pointer"}}  htmlFor="langEn" >English</label>
                        <input type="radio" value="1" name="lang" className="radio" id="langEn" checked={language ==="1"}/>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="receiver" className="form-label">
                      ادخل اسم المُرسَل إليه Receiver name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="receiver"
                      value={receiver}
                      onChange={handleReceiverChange}
                    />
                  </div>
                  <div className="mb-3 mt-3">
                    <label htmlFor="sender" className="form-label">
                      ادخل اسم المُرسِل Sender name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="sender"
                      value={sender}
                      onChange={handleSenderChange}
                    />
                  </div>
                  <div className="last-input">
                    <label htmlFor="message" className="form-label">
                      ادخل الرسالة Message
                    </label>
                    <textarea
                      className="form-control"
                      id="message"
                      maxLength={200}
                      style={{ resize: "none" }}
                      rows="4"
                      value={message}
                      onChange={handleMessageChange}
                    />
                    <small>{200 - message.length} حرف متبقي</small>
                  </div>
                </div>
                <div id="download-button" className="text-center ">
                  <button
                    disabled={receiver === ""}
                    className="btn btn-primary bb"
                    onClick={handleDownload}
                  >
                    قم بالتنزيل Download now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gratitude;